import React from 'react';
import { useQuery } from '@tanstack/react-query';

import type { MissingDetail, UseQueryWrapper } from '../../../types';

import type { GetMissingDetailsParams } from '../../../Domain/Dashboard/Services';
import { dashboardService } from '../../../Domain/Dashboard/Services';

import { useSnakeBar } from '../../useSnakeBar';

type GetMissingDetailsQueryVariables = GetMissingDetailsParams;

type GetMissingDetailsQueryResultData = {
  data: MissingDetail[];
  totalCount: number;
};

const queryFn = (variables: GetMissingDetailsQueryVariables) => async () => {
  const response = await dashboardService.getMissingDetails(variables);
  return response.data;
};

const QUERY_KEY = 'getMissingDetails';

export const useDashboardGetMissingDetailsQuery: UseQueryWrapper<
  GetMissingDetailsQueryResultData,
  GetMissingDetailsQueryVariables
> = ({ variables, options }) => {
  const { showErrorSnakeBar } = useSnakeBar();

  const onError = React.useCallback(() => {
    showErrorSnakeBar({ method: QUERY_KEY });
  }, [showErrorSnakeBar]);

  const select = React.useCallback(data => {
    return {
      data: data['hydra:member'],
      totalCount: data['hydra:totalItems'],
    };
  }, []);

  return useQuery<GetMissingDetailsQueryResultData>([QUERY_KEY, ...Object.values(variables)], queryFn(variables), {
    select,
    onError,
    ...(options || {}),
  });
};
